const keyboardDatePickerFormActions = {
  deadline: 'Fecha límite'
};

export default keyboardDatePickerFormActions;
